const { REACT_APP_BACKEND_URL } = process.env;

export const API_BASE_URL = `${REACT_APP_BACKEND_URL}/api`;

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    ME: '/auth/me',
    MFA_SETUP: '/auth/mfa/setup',
  },
  JURISDICTIONS: '/jurisdictions',
  DASHBOARD: {
    STATS: '/dashboard/stats',
  },
  PARCELS: '/parcels',
  PAYMENTS: '/payments',
  CERTIFICATIONS: '/certifications',
  IMPORTS: '/imports/upload',
  AUDIT_LOGS: '/audit-logs',
  HEALTH: '/health',
};

export const USER_ROLES = {
  SYSTEM_ADMIN: 'SystemAdmin',
  COLLECTOR_ADMIN: 'CollectorAdmin',
  COLLECTOR_STAFF: 'CollectorStaff',
  MUNICIPAL_VIEWER: 'MunicipalViewer',
  TITLE_COMPANY_USER: 'TitleCompanyUser',
  PUBLIC_USER: 'PublicUser',
};
